import client from './client';
import { Programs } from '../constants';

export const readinessApi = {
    /**
     * Triggers backend warmup if frontend cache is cold.
     * Fire-and-forget.
     * @param {string} programId
     */
    triggerWarmup: async (programId) => {
        const pid = programId || Programs.ISEE;
        const keys = [
            `readiness_state_${pid}_synonym_v2`,
            `readiness_state_${pid}_single_word_completion_v2`
        ];

        const hasCache = keys.some(k => !!localStorage.getItem(k));

        if (!hasCache) {
            console.log(`[READINESS] Cold start detected for ${pid}. Triggering backend warmup...`);
            try {
                await client.post(`/api/${pid}/progress/warmup`);
                console.log("[READINESS] Warmup signal sent.");
            } catch (e) {
                console.error("[READINESS] Warmup trigger failed", e);
            }
        } else {
            console.log("[READINESS] Cache warm. Skipping backend warmup.");
        }
    },
};
